import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

import ApiAdmin from '@/modules/api/admin'
import ApiDispatchReservation from '@/modules/api/dispatch/reservations'
import ApiRoutingReservation from '@/modules/api/routing/reservations'

import AccessDenied from '@/components/Error/AccessDenied'
import MissingPage from '@/components/Error/404'

import Login from '@/components/App/Login'
import PasswordReset from '@/components/App/PasswordReset'
import PasswordResetDriver from '@/components/App/PasswordResetDriver'
import StyleGuide from '@/components/App/StyleGuide'
import test from '@/components/TestUpload'

import Admin from '@/components/Admin'
import Brands from '@/components/Brands'
import Consumer from '@/components/Consumer'
import ConsumerList from '@/components/Consumer/List'
import Corporate from '@/components/Corporate'
import CreateCorporate from '@/components/Corporate/CreateProfile'
import CorporateInvoice from '@/components/Corporate/Invoice'
import CorporateProfile from '@/components/Corporate/CorporateProfile'
import Dispatch from '@/components/Dispatch'
import DispatchMapDetails from '@/components/Dispatch/DispatchMapDetails'
import DispatchReservations from '@/components/Dispatch/DispatchReservations'
import PromoList from '@/components/Promo'
import PromoView from '@/components/Promo/PromoView'
import Routing from '@/components/Routing'
import Reports from '@/components/Reports'
import ImportRsvp from '@/components/ImportRsvp'

import Pricing from '@/components/Pricing'
import Services from '@/components/Services'

import Geofence from '@/components/Geofences'
import GeofenceInstructionPreview from '@/components/Geofences/InstructionPreview'

import Provider from '@/components/Provider'
import ProviderAvailability from '@/components/ProviderAvailability'
import ProviderList from '@/components/Provider/List'
import ProviderDeductions from '@/components/ProviderDeductions'
import ProviderPayouts from '@/components/ProviderPayouts'
import ProviderPrintPlacard from '@/components/Provider/PrintPlacard'

// import RsvpDetails from '@/components/RsvpDetails'
import RsvpDetails2 from '@/components/RsvpDetails/index2'
import Transactions from '@/components/Transactions'

// import PackageDetails from '@/components/PackageDetails'
import PackageDetails2 from '@/components/PackageDetails/index2'

import Flights from '@/components/Flights'
import FlightDetails from '@/components/FlightDetails'
import FlightNew from '@/components/FlightCreate'

import MarketingAds from '@/components/MarketingAds'
import AdDetails from '@/components/MarketingAds/AdDetails'

import Filters from '@/components/Filters'
import FilterDetails from '@/components/Filters/FilterDetails'

import Settings from '@/components/Settings'

import Coverage from '@/components/Coverage'
import DispatchLaxit from '@/components/Laxit'
import Runs from '@/components/Runs'
import Logs from '@/components/devlogs'
import AutoDispatchLogs from '@/components/devlogs/auto-dispatch'
import DiscountCodes from '@/components/DiscountCodes'
import DiscountCodesDetails from '@/components/DiscountCodes/Details'
import Quotation from '@/components/Quotation'
import DownloadProfile from '@/components/Provider/DownloadProfile'
import Airtag from '@/components/Airtag'
import Insurance from '@/components/Insurance'

import AdminCode from '@/components/AdminCode'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Transactions
    },
    {
      path: '/thispagedoesnotexist',
      name: 'MissingPage',
      component: MissingPage
    },
    {
      path: '/accessdenied',
      name: 'AccessDenied',
      component: AccessDenied
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/reset',
      name: 'PasswordReset',
      component: PasswordReset
    },
    {
      path: '/reset-driver',
      name: 'PasswordResetDriver',
      component: PasswordResetDriver
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin
    },
    {
      path: '/brands',
      name: 'Brands',
      component: Brands
    },
    {
      path: '/consumer/:id',
      name: 'Consumer',
      component: Consumer
    },
    {
      path: '/consumers',
      name: 'ConsumerList',
      component: ConsumerList
    },
    {
      path: '/corporate',
      name: 'Corporate',
      component: Corporate
    },
    {
      path: '/corporate/new',
      name: 'CreateCorporate',
      component: CreateCorporate
    },
    {
      path: '/corporate/:id',
      name: 'CorporateProfile',
      component: CorporateProfile
    },
    {
      path: '/corporate/:id/invoice/:invoiceId',
      name: 'CorporateInvoice',
      component: CorporateInvoice
    },
    {
      path: '/dispatch',
      name: 'Dispatch',
      component: Dispatch
    },
    {
      path: '/dispatch/map',
      name: 'DispatchMapDetails',
      component: DispatchMapDetails
    },
    {
      path: '/dispatch/reservations',
      name: 'DispatchReservations',
      component: DispatchReservations
    },
    {
      path: '/dispatch/laxit',
      name: 'DispatchLaxit',
      component: DispatchLaxit
    },
    {
      path: '/promo',
      name: 'PromoList',
      component: PromoList
    },
    {
      path: '/promo/:id',
      name: 'PromoView',
      component: PromoView
    },
    {
      path: '/routing',
      name: 'Routing',
      component: Routing
    },
    {
      path: '/package/:id',
      name: 'PackageDetails',
      component: PackageDetails2
    },
    {
      path: '/flights',
      name: 'Flights',
      component: Flights
    },
    {
      path: '/flight/:id',
      name: 'FlightDetails',
      component: FlightDetails
    },
    {
      path: '/flight-book',
      name: 'FlightNew',
      component: FlightNew
    },
    {
      path: '/geofence',
      name: 'Geofence',
      component: Geofence
    },
    {
      path: '/geofence/preview',
      name: 'InstructionPreview',
      component: GeofenceInstructionPreview
    },
    {
      path: '/provider/:id',
      name: 'Provider',
      component: Provider
    },
    {
      path: '/provider/:id/download',
      name: 'DownloadProfile',
      component: DownloadProfile
    },
    {
      path: '/provider-availability',
      name: 'ProviderAvailability',
      component: ProviderAvailability
    },
    {
      path: '/provider-payouts',
      name: 'ProviderPayouts',
      component: ProviderPayouts
    },
    {
      path: '/provider-deductions',
      name: 'ProviderDeductions',
      component: ProviderDeductions
    },
    {
      path: '/provider/:id/print-placard',
      name: 'ProviderPrintPlacard',
      component: ProviderPrintPlacard
    },
    {
      path: '/providers',
      name: 'ProviderList',
      component: ProviderList
    },
    {
      path: '/reservation/:id',
      name: 'RsvpDetails',
      component: RsvpDetails2
    },
    {
      path: '/reports',
      name: 'Reports',
      component: Reports
    },
    {
      path: '/import-rsvp',
      name: 'ImportRsvp',
      component: ImportRsvp
    },
    {
      path: '/transactions',
      name: 'Transactions',
      component: Transactions
    },
    {
      path: '/ads',
      name: 'MarketingAds',
      component: MarketingAds
    },
    {
      path: '/ads/:id',
      name: 'AdDetails',
      component: AdDetails
    },
    {
      path: '/filters',
      name: 'Filters',
      component: Filters
    },
    {
      path: '/filter/:id',
      name: 'FilterDetails',
      component: FilterDetails
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings
    },
    {
      path: '/coverage',
      name: 'Coverage',
      component: Coverage
    },
    {
      path: '/pricing',
      name: 'Pricing',
      component: Pricing
    },
    {
      path: '/services',
      name: 'Services',
      component: Services
    },
    {
      path: '/services/:brandId/:serviceId',
      name: 'ServicesDetails',
      component: Services
    },
    {
      path: '/runs',
      name: 'Runs',
      component: Runs
    },
    {
      path: '/discount-codes',
      name: 'Discount Codes',
      component: DiscountCodes
    },
    {
      path: '/discount-codes/:id',
      name: 'Discount Codes Details',
      component: DiscountCodesDetails
    },
    {
      path: '/airtag',
      name: 'Airtag',
      component: Airtag
    },
    {
      path: '/insurance',
      name: 'Insurance',
      component: Insurance
    },
    {
      path: '/code',
      name: 'AdminCode',
      component: AdminCode
    },
    {
      path: '/xxquotation',
      name: 'Quotation',
      component: Quotation
    },
    {
      path: '/xxlogs',
      name: 'Logs',
      component: Logs
    },
    {
      path: '/xxxlogs',
      name: 'AutoDispatchLogs',
      component: AutoDispatchLogs
    },
    {
      path: '/style-guide',
      name: 'StyleGuide',
      component: StyleGuide
    },
    {
      path: '/test',
      name: 'test',
      component: test
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.name === null) {
    next('/thispagedoesnotexist')
    return
  }
  if (to.name === 'Login') {
    if (store.state.session.user.id !== null) {
      next('/dispatch')
      return
    }
    store.commit('sideMenu/hide')
    next()
    return
  }

  if (to.name === 'PasswordReset') {
    if (store.state.session.user.id !== null) {
      next('/reset')
      return
    }
    next()
    return
  }

  if (to.name === 'PasswordResetDriver') {
    if (store.state.session.user.id !== null) {
      next('/reset-driver')
      return
    }
    next()
    return
  }

  if (store.state.session.user.id === null) {
    // check session token
    let sessionToken = router.app.$plugins.storage.getSessionToken()
    if (sessionToken === null) {
      store.commit('sideMenu/hide')
      next('/login')
      return
    }

    store.commit('session/showLoader')
    router.app.$sdk.get('/admin/auth', {
      token: sessionToken
    }, r => {
      store.commit('session/hideLoader')
      store.commit('sideMenu/hide')
      if (r.error) {
        router.app.$plugins.storage.removeSessionToken()
        next('/login')
        return
      }
      store.commit('session/setUser', {
        id: r.id,
        firstName: r.firstName,
        lastName: r.lastName,
        phone: r.phone,
        email: r.email,
        photoUrl: r.avatarUrl === null ? 'https://s3-us-west-2.amazonaws.com/staging-backoffice/staging/default-user.jpg' : r.avatarUrl,
        access: r.access.permissions,
        accessLoad: false
      })
      store.commit('session/setSessionToken', sessionToken)
      router.app.$plugins.storage.setSessionToken(sessionToken)
      router.app.$plugins.fcm.start(router.app)

      // get RSVP filters
      if (to.name === 'Dispatch') {
        ApiDispatchReservation.initDispatchReservations(router.app)
      }
      if (['Dispatch', 'Routing'].indexOf(to.name) > -1) {
        ApiRoutingReservation.initRoutingReservations(router.app)
      }
      ApiAdmin.getAdminList(router.app)
      next()
    })

    return
  }

  if (to.name === 'Dispatch' && !router.app.$store.state.reservation.reservationFilters.length) {
    ApiDispatchReservation.initDispatchReservations(router.app)
  }
  if (['Dispatch', 'Routing'].indexOf(to.name) > -1 && !router.app.$store.state.routing.reservationFilters.length) {
    ApiRoutingReservation.initRoutingReservations(router.app)
  }

  store.commit('sideMenu/hide')
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js